module.exports = __webpack_public_path__ + "img/stock-photo-car-service-transportation-concept-tow-truck-transpo.da662f84.webp";